import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { IAuthState } from 'src/modules/authentication/+store/auth.state';
import { getUserInfo } from 'src/modules/authentication/+store/auth-selector';
import { logOutAction } from 'src/modules/authentication/+store/actions/auth.actions';
import { UnsupportedWebAccessService } from 'src/modules/shared/services/unsupported-web-access.service';

/**
 * Contractors are not supported in a browser on the web app. This catches sessions
 * that are already signed in there - the logout effect takes them to the download
 * screen once the session is cleared.
 */
@Injectable({
  providedIn: 'root'
})
export class AppRequiredGuard implements CanActivateChild {

  constructor(
    private readonly store: Store<IAuthState>,
    private unsupportedWebAccessService: UnsupportedWebAccessService
  ) {}

  canActivateChild(): Observable<boolean> {
    return this.store.pipe(
      select(getUserInfo),
      take(1),
      map(user => {
        if (!this.unsupportedWebAccessService.isContractorOnUnsupportedWeb(user)) {
          return true;
        }
        this.unsupportedWebAccessService.flagAppRequiredScreen();
        this.store.dispatch(logOutAction());
        return false;
      })
    );
  }
}
